import { parseHandleBars } from 'modules/HandlebarsTemplates';
import { isMl3App, isAndroid, isDeviceId } from 'modules/DeviceOptions';

import { MapUpdate, MapCreate } from 'modules/API';

window.MapCreateImageObj = undefined;
window.MapCreateImageUploadCallback = undefined;
window.MapEdditingObj = undefined;

let selectedMapTemplate;

// HANDLEBARS
const MapUnpublishAlertTemplate = parseHandleBars(
  window.resolveLang('「{{this}}」マップを非公開しますか？')
);
const MapPublishAlertTemplate = parseHandleBars(
  window.resolveLang('「{{this}}」マップを公開しますか？')
);

// ==================================================================
// CATEGORY SELECT
const mapCategorySelector = $('#mapCategorySelector');
const $select2 = mapCategorySelector.select2({
  placeholder: window.resolveLang('カテゴリ選択'),
  closeOnSelect: false,
  templateResult(data, container) {
    if (data.element) {
      $(container).addClass($(data.element).attr('class'));
      $(container).data('parent', $(data.element).data('parent'));
    }
    return data.text;
  },
  language: {
    noResults() {
      return window.resolveLang('カテゴリがありません');
    }
  }
});

const select2Interval = setInterval(() => {
  if ($('.select2-search__field').length > 0) {
    $('.select2-search__field').prop('disabled', true);
    clearInterval(select2Interval);
  }
}, 1000);

mapCategorySelector.on('select2:select select2:unselect', e => {
  const val = e.params.data.id;
  const order = $select2.data('orderedCollection') || [];
  switch (e.type) {
    case 'select2:select':
      order.push({ lcategory: val });
      break;
    case 'select2:unselect': {
      const index = order
        .map(cat => {
          return cat.lcategory || cat.category;
        })
        .indexOf(val);
      if (index >= 0) {
        order.splice(index, 1);
      }
      break;
    }
    default:
      break;
  }

  reorderSelect2();
});

function setSelect2(orderedCollection) {
  orderedCollection = orderedCollection || [];
  const list = orderedCollection.map(map => {
    // return map.lcategory || map.category;
    return map.lcategory;
  });
  mapCategorySelector.data('orderedCollection', orderedCollection);
  mapCategorySelector.val(list).trigger('change');
  reorderSelect2();
}

function reorderSelect2() {
  const $container = $select2.next('.select2-container');
  const $tags = $container.find('li.select2-selection__choice');
  const $input = $tags.last().next();
  const order = mapCategorySelector.data('orderedCollection') || [];

  // apply tag order
  order.forEach(catObj => {
    const $el = $tags.filter((i, tag) => {
      return tag.title === (catObj.lcategory || catObj.category);
    });
    $input.before($el);
  });
}

// CATEGORY SELECT
// ==================================================================
// ==================================================================

//======================================
//EVENTS
//
$(document).on('click', '.selectMapTemplateModalOpen', e => {
  e.preventDefault();
  if (window.accountClass.checkPreviewer()) {
    return;
  }

  window.closeModal();
  const that = e.currentTarget;
  setTimeout(() => {
    window.openModal(`#${$(that).data('modalid')}`);
  }, 400);
});

$(document).on('click', '.createMapModalOpen', e => {
  e.preventDefault();

  $('#cmMapName').val('');
  $('#cmMapDesc').val('');
  $('#mapDialySortingSelector').val('0');

  setSelect2(null);

  document.getElementById('cmPhotoSelect').value = '';
  $('#cmCoverImage').css('background', 'none');
  createMapFlag = 0;
  $('.doCreateMap').html(window.resolveLang('作成'));
  $('.cmTitle').html($(e.currentTarget).data('templatetitle'));

  if (isMl3App && isAndroid) {
    window.NativeRemoveAllImages();
  }

  selectedMapTemplate =
    MapClass.template[$(e.currentTarget).data('maptemplateindex')];

  if (selectedMapTemplate === MapClass.template.openMap) {
    if (isMl3App && isDeviceId) {
      window.closeModal();
      setTimeout(() => {
        window.openModal('#mDeviceRegister');
      }, 400);
      return;
    }
  }

  window.closeModal();
  const that = e.currentTarget;
  setTimeout(() => {
    window.openModal(`#${$(that).data('modalid')}`);
  }, 400);
});

$(document).on('click', '.cmPhotoSelect', () => {
  if (isMl3App && isAndroid) {
    window.ml3UploadMode = 2;
    window.NativeAndroidShowSingleCameraRoll();
  } else {
    $('#cmPhotoSelect').trigger('click');
  }
});

$(document).on('change', '#cmPhotoSelect', () => {
  if ($('#cmPhotoSelect').get(0).files.length > 1) {
    $('#cmPhotoSelect').val('');
    setTimeout(() => {
      alert(window.resolveLang('恐れ入りますが、1 枚だけ選択可能です'));
    }, 300);
  } else {
    //ファイルオブジェクト取得
    const file = $('#cmPhotoSelect').get(0).files[0];

    //Preview Local Photo
    const preview = $('#cmCoverImage');

    window.loadImage(
      file,
      img => {
        preview.css('background', `url('${img.toDataURL()}') no-repeat`);
        preview.css('background-size', 'cover');
        preview.css('background-position', 'center');
      },
      { orientation: true, maxWidth: 600 }
    );
  }
});

$(document).on('click', '.doCreateMap', () => {
  createMap();
});

$(document).on('click', '.doShareMap', e => {
  e.stopPropagation();
  e.preventDefault();

  doShareMap($(e.currentTarget).data('mapid'));
});

$(document).on('click', '.doCloseMap', e => {
  e.stopPropagation();
  e.preventDefault();

  doShareMap($(e.currentTarget).data('mapid'), true);
});

$(document).on('click', '.doEditMap', e => {
  e.stopPropagation();
  e.preventDefault();

  if (window.accountClass.checkPreviewer()) {
    return;
  }

  createMapFlag = 1;
  $('.doCreateMap').html(window.resolveLang('完了'));
  $('.cmTitle').html(window.resolveLang('マップを編集'));

  if (
    Gdata.CurrentMap.ori &&
    Gdata.CurrentMap.ori[0] &&
    Gdata.CurrentMap.ori[0].is_lifemap === '1'
  ) {
    window.disableElm($('#cmMapName'));
  }

  const map = Gdata.CurrentMap.ori[0];
  $('#cmMapName').val(map.title);
  $('#cmMapDesc').val(map.description);
  let dialy_order = '0';
  if (map.dialy_order) {
    dialy_order = map.dialy_order;
  }
  $('#mapDialySortingSelector').val(dialy_order);

  document.getElementById('cmPhotoSelect').value = '';
  const imageSrc = `${
    window.ImageDomainURLRead
  }beta/2ffc7af154cd9c098f7aa6346981b8fc7c359395658d3c6668d6c8560d9c3d96/${
    map.image_id
  }%3Fsize%3D500`;
  $('#cmCoverImage').css('background', `url("${imageSrc}") no-repeat`);
  $('#cmCoverImage').css('background-size', 'cover');
  $('#cmCoverImage').css('background-position', 'center');

  setSelect2($.extend([], map.categories));

  window.openModal('#CreateMapModal');

  $('#cmCoverImageImg').data('imageid', map.image_id);
  $('#cmCoverImageImg').attr('src', imageSrc);
});

let createMapFlag = 0;

//======================================
//FUNCTIONS
//
function createMap() {
  window.freezeModal('#CreateMapModal');
  window.disableElm('.doCreateMap');

  const mapObj = {
    title: $('#cmMapName').val(),
    description: $('#cmMapDesc').val(),
    dialy_order: $('#mapDialySortingSelector').val()
  };

  // ==========================================
  // category
  mapObj.categories = mapCategorySelector.data('orderedCollection') || [];
  // filter category
  mapObj.categories = _.filter(mapObj.categories, cat => {
    return !!window.CONFIG_ARR.map.categories[cat.lcategory];
  });

  // // remove parent categories
  // mapObj.categories = mapObj.categories.filter(function(map){
  //  return map.category;
  // });
  // // reselect parent categories
  // var copy = _.map(CONFIG_ARR.map.categories, _.clone);
  // _.forEach(mapObj.categories, function(selectedCat){
  //  if (copy.length <= 0) {
  //    return false;
  //  }

  //  _.forEach(copy, function(lcat, index){
  //    var contains = _.includes(lcat.childCategories, selectedCat.category);
  //    if (contains) {
  //      copy.splice(index, 1);
  //      mapObj.categories.push({ lcategory: lcat.title });
  //      return false;
  //    }
  //  });
  // });
  // // remove duplicates
  // mapObj.categories = _.uniqBy(mapObj.categories, function(obj){
  //  return obj.lcategory || 'category'+obj.category;
  // });
  // mapObj.categories = _.uniqBy(mapObj.categories, function(obj){
  //  return obj.category || 'lcategory'+obj.lcategory;
  // });
  // ==========================================

  if (createMapFlag === 1) {
    const currentMap = Gdata.CurrentMap.ori[0];
    mapObj._id = currentMap._id;
    if (MapClass.checkShared(currentMap.share_id)) {
      if (
        !mapObj.categories ||
        !mapObj.categories.find(obj => {
          return obj.lcategory;
        })
      ) {
        window.unfreezeModal('#CreateMapModal');
        window.enableElm('.doCreateMap');
        return alert(window.resolveLang('マップのカテゴリを選択してください'));
      }

      if (
        currentMap.lang_edited &&
        (mapObj.title !== currentMap.title ||
          mapObj.description !== currentMap.description)
      ) {
        if (
          !confirm(
            window.window.resolveLang(
              '日本語以外で手動で編集した翻訳データーは削除されます。よろしいですか？'
            )
          )
        ) {
          window.unfreezeModal('#CreateMapModal');
          window.enableElm('.doCreateMap');
          return;
        }
      }
    }

    if (mapObj.title === currentMap.title) {
      delete mapObj.title;
    }
    if (mapObj.description === currentMap.description) {
      delete mapObj.description;
    }
  } else if (selectedMapTemplate) {
    //init template - and template can't be changed
    mapObj.template_id = selectedMapTemplate;
    if (selectedMapTemplate === MapClass.template.openMap) {
      mapObj.share_id = MapClass.share_id.closed_share;
    }
  }

  if (mapObj.title === '') {
    alert(window.resolveLang('マップのタイトルを入力してください'));
    window.unfreezeModal('#CreateMapModal');
    window.enableElm('.doCreateMap');
    return;
  }

  const UploadMapHere = async () => {
    let apiToCall = MapCreate;
    if (createMapFlag === 1) {
      apiToCall = MapUpdate;
    }

    try {
      const resultMap = await apiToCall({
        ...mapObj,
        session: Cookies.get(CookieSession)
      });

      window.location.href = `/maps/archive/${resultMap._id}`;
    } catch (error) {
      console.log(error);
      window.unfreezeModal('#CreateMapModal');
      window.enableElm('.doCreateMap');
    }
  };

  if (isMl3App && isAndroid) {
    if (window.MapCreateImageObj) {
      window.MapEdditingObj = mapObj;
      window.MapCreateImageUploadCallback = UploadMapHere;
      window.NativeUploadImages();
    } else {
      UploadMapHere();
    }
  } else if ($('#cmPhotoSelect').get(0).files.length > 0) {
    //Check and Upload Photo first
    //upload here
    window.registPicture({
      file: $('#cmPhotoSelect').get(0).files[0],
      ajaxRequest: window.myPhotoAjaxRequest,
      success(data) {
        // var data = {"code":"S0000","fileids":[{"file":"gmgzFjx.jpg","fileid":"d_6d74311c5ffd4800c86e0bfbf52fb0483242b649\/f_0000000000_dc71742f810dd104c97661bc0b9099be5b18e966.jpg"}]};
        if (data.code === 'S0000') {
          mapObj.image_id = data.fileids[0].fileid;
          UploadMapHere();
        } else {
          UploadMapHere();
        }
      },
      error() {
        alert(window.resolveLang('写真アップロードに失敗しました'));
        UploadMapHere();
      }
    });
  } else {
    UploadMapHere();
  }
}

const doShareMap = async (mapID, close) => {
  if (isMl3App && isDeviceId) {
    window.openModal('#mDeviceRegister');
    return;
  }

  if (window.accountClass.checkPreviewer()) {
    return;
  }

  if (mapID) {
    if (
      Gdata.MyMaps.loaded === 2 &&
      Gdata.MyMaps.dic &&
      Gdata.MyMaps.dic[mapID]
    ) {
      const map = Gdata.MyMaps.dic[mapID];

      if (map.is_lifemap === '1') {
        return alert(window.resolveLang('「ライフマップ」は公開できません！'));
      }

      let proceed = false;

      if (close) {
        const editLangWarning = map.lang_edited
          ? `（${window.window.resolveLang(
              '日本語以外で手動で編集した翻訳データーは削除されます。よろしいですか？'
            )}）`
          : '';
        proceed = confirm(
          MapUnpublishAlertTemplate(map.title) + editLangWarning
        );
      } else {
        if (!map.image_id || map.image_id === null || map.image_id === '') {
          alert(
            window.resolveLang(
              'このマップを公開するには、マップの画像を設定してください!'
            )
          );
          return;
        }

        if (
          !map.categories ||
          !map.categories.find(obj => {
            return obj.lcategory;
          })
        ) {
          return alert(
            window.resolveLang(
              'このマップを公開するには、マップのカテゴリを選択してください!'
            )
          );
        }

        proceed = confirm(MapPublishAlertTemplate(map.title));
      }

      if (!proceed) {
        return;
      }

      const mapObj = $.extend({}, Gdata.MyMaps.dic[mapID]);
      if (close) {
        mapObj.share_id =
          mapObj.template_id === MapClass.template.openMap
            ? MapClass.share_id.closed_share
            : MapClass.share_id.closed;
      } else {
        mapObj.share_id =
          mapObj.template_id === MapClass.template.openMap
            ? MapClass.share_id.shared
            : MapClass.share_id.open;
      }

      delete mapObj.title;
      delete mapObj.description;

      mapObj.session = Cookies.get(CookieSession);

      try {
        const result = await MapUpdate(mapObj);
        // success
        const oriObj = Gdata.MyMaps.dic[mapID];
        // eslint-disable-next-line no-restricted-syntax
        for (const index in result) {
          if (result[index]) {
            oriObj[index] = result[index];
          }
        }
        if (
          mapObj.share_id === MapClass.share_id.closed_share ||
          mapObj.share_id === MapClass.share_id.closed
        ) {
          delete oriObj.lang;
        }
        window.PopulateAndSortByUpdateDatetime(Gdata.MyMaps.ori);
        window.APIGetMyMaps({
          htmlTemplate: 'myMapListInnerTemplate'
        });

        if (Gdata.CurrentMap.dic && Gdata.CurrentMap.dic[mapObj._id]) {
          Gdata.CurrentMap.dic[mapObj._id].share_id = mapObj.share_id;
          Gdata.CurrentMap.dic[mapObj._id].update_datetime =
            mapObj.update_datetime;
          //reload wall
          window.setCurrentMap();
        }

        //profile page
        if (window.ProfilePage) {
          window.ProfilePage.reset();
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
